import {
  DocumentNode,
  OperationVariables,
  QueryHookOptions,
  TypedDocumentNode,
  useQuery,
} from '@apollo/client';


export function useCacheQuery<
  TData = unknown,
  TVariables extends OperationVariables = OperationVariables
>(
  query: DocumentNode | TypedDocumentNode<TData, TVariables>,
  options?: QueryHookOptions<NoInfer<TData>, NoInfer<TVariables>>
) {
  const { data, loading, ...rest } = useQuery(query, {
    fetchPolicy: options?.fetchPolicy ?? 'cache-and-network',
    ...options,
  });

  const customLoading = loading && data === undefined;

  return { data, loading: customLoading, ...rest };
}
